import { useTranslation } from "@opendash/i18n";
import { Flex, Form, InputNumber, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { getFieldPath } from "../../../functions/Utility";
import { SpecificRule } from "../../../types/RuleTypes";
import { ListFieldContext } from "../LaterForm";
import { RuleContext } from "../LaterRule";
import { PeriodSelect } from "./PeriodSelect";

type Props = {};

const EVERY_TYPE = ["weekend", "weekday"];
const TIME_RANGE = ["starting_on_the", "between_the"];

export const Every_TimeInput = observer((props: Props) => {
  const t = useTranslation();
  const rule = useContext(RuleContext) as SpecificRule<"every">;
  const field = useContext(ListFieldContext);

  const typeOptions = useMemo(
    () =>
      EVERY_TYPE.map((type) => ({
        label: t("opendash:cron.later.every.type." + type),
        value: type,
      })),
    []
  );

  const timeOptions = useMemo(
    () =>
      TIME_RANGE.map((type) => ({
        label: t("opendash:cron.later.every.timeRange." + type),
        value: type,
      })),
    []
  );

  return (
    <Flex vertical gap="small" style={{ width: "100%" }}>
      <Form.Item name={[getFieldPath(field), "periodType"]}>
        <Select
          options={typeOptions}
          allowClear
          placeholder={t("opendash:cron.later.every.type.placeholder")}
        />
      </Form.Item>

      {!rule?.periodType && (
        <>
          <Flex gap="small">
            <Form.Item name={[getFieldPath(field), "number"]}>
              <InputNumber
                placeholder={t("opendash:cron.later.every.number.placeholder")}
              />
            </Form.Item>

            <Form.Item name={[getFieldPath(field), "period"]}>
              <PeriodSelect />
            </Form.Item>
          </Flex>

          <Form.Item name={[getFieldPath(field), "timeRange"]}>
            <Select
              options={timeOptions}
              allowClear
              placeholder={t("opendash:cron.later.every.timeRange.placeholder")}
            />
          </Form.Item>

          {rule?.timeRange && (
            <Flex gap="small">
              <Form.Item name={[getFieldPath(field), "timeRangeNumberStart"]}>
                <InputNumber
                  placeholder={t(
                    "opendash:cron.later.every.timeRangeNumberStart"
                  )}
                />
              </Form.Item>

              {rule?.timeRange === "between_the" && (
                <Form.Item name={[getFieldPath(field), "timeRangeNumberEnd"]}>
                  <InputNumber
                    min={(rule.timeRangeNumberStart ?? 0) + 1}
                    placeholder={t(
                      "opendash:cron.later.every.timeRangeNumberEnd"
                    )}
                  />
                </Form.Item>
              )}
            </Flex>
          )}
        </>
      )}
    </Flex>
  );
});
